import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { allBooksCategories } from "../../data/CategoriesData"
import { apiFetch } from "../../hooks/apiFetch"
import { useTranslation } from 'react-i18next';

export default function RequestAddBook() {
    const { t, i18n } = useTranslation();
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const [errorMessage, setErrorMessage] = useState('');
    const [dataUpdate, setDataUpdate] = useState(false);

    const thisYear = new Date().getFullYear();

    async function onSubmit(data) {
        setDataUpdate(true);
        console.log("Form data: ", data);
        // Debug: Check form data
        // if (data.publishDate) {
        //     data.publishDate.toString();
        // }
        // if (data.numberOfPages) {
        //     parseInt(data.numberOfPages);
        // }

        try {
            const response = await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/mailer/add-book`, {
                method: "POST",
                body: JSON.stringify(data)
            });

            // Redirect to another page after successful submission
            if (response.isSuccess) {
                setDataUpdate(true)
                setTimeout(() => {
                    window.location.reload()
                    // navigate('/');
                }, 3000);

            } else {
                // console.log(response, response.message, response.status);
                setErrorMessage(t("errorTryAgain"), response.message);
            }
        } catch (error) {
            console.error("Error during form submission: ", error); // Debug: Check error
            setErrorMessage(t("errorGetSupport"));
        } finally {
            setDataUpdate(false);
        }
    }


    return (
        <form id='RequestAddBook-form' className='d-flex flex-column shadow mx-auto my-5 gap-2 text-start bg-white p-4 rounded' onSubmit={handleSubmit(onSubmit)}>
            {errorMessage && <p className='errors-msg bg-warning p-1 rounded' id='error-message'>{errorMessage}</p>}
            <input
                className={`form-control border`}
                type="text"
                placeholder={t("BookTitle")}
                {...register("title", { required: true, minLength: 4 })} />
            {errors.title && <p className='errors-msg'>
                {i18n.language === "ar" ? "عنوان الكتاب مطلوب أكبر من ٤ أحرف" : "Book title is required and must be more than 4 characters"}
            </p>}

            <input
                className={`form-control border`}
                type="text"
                placeholder={t("Author")}
                {...register("author", { required: true, minLength: 10 })} />
            {errors.author && <p className='errors-msg'>{t("errorName")}</p>}
            <div className="input-group input-group-sm">
                <span className="input-group-text">{t("bookCategory")}</span>
                <select className="form-select" aria-label="request-books-category"
                    {...register("category", { required: true })}
                // onChange={() => handleSelect}
                >
                    <option value=""></option>
                    {allBooksCategories.map((category, index) =>
                        <option key={index} value={category.ar}>{i18n.language === "ar" ? category.ar : category.en}</option>
                    )}
                </select>
                {errors.category && <p className='errors-msg'>{t("requiered")}</p>}
            </div>
            <input
                className={`form-control border`}
                type="number"
                placeholder={t("PublishDate")}
                {...register("publishDate", { required: true, pattern: /^\d{4}$/, min: 1980, max: { thisYear } })} />
            {errors.publishDate && <p className='errors-msg'>
                {i18n.language === "ar" ? "الارقام فقط للسنة - تاريخ النشر أكبر من ١٩٨٠م" : "year must be a number - publish date more than 1980"}
            </p>}
            <input
                className={`form-control border`}
                type="number"
                min="20"
                max="2000"
                placeholder={t("PageCount")}
                onChange={(e) => setValue("numberOfPages", parseInt(e.target.value))}
            />
            {errors.numberOfPages && <p className='errors-msg'>{i18n.language === "ar" ? "عدد الصفحات أكبر من ٢٠ صفحة" : "pages more than 20"}</p>}

            <button className="btn btn-light-beige text-white"
                type='submit'>{t("Send")}</button>
            {errorMessage &&
                <div className="alert alert-danger alert-dismissible fade show" role="alert">
                    {errorMessage}
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>}
            {dataUpdate &&
                <div className="alert alert-success alert-dismissible fade show" role="alert">
                    {i18n.language === 'ar' ?
                        "تم إرسال طلبك بنجاح .. شكرا لك"
                        :
                        "Your request has been sent successfully .. Thank you"}
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>}
        </form>
    )
}